import _en from 'element-ui/lib/locale/lang/en'
import _zhCN from 'element-ui/lib/locale/lang/zh-CN'
import _zhTW from 'element-ui/lib/locale/lang/zh-TW'

export default {
  'en': _en,
  'zh-CN': _zhCN,
  'zh-TW': _zhTW
}



// WEBPACK FOOTER //
// ./packages/helper/i18n/element-locales.js